import PropTypes from 'prop-types';
import RenderBlocks from '@plone/volto/components/theme/View/RenderBlocks';

const HERO_BLOCK_TYPES = new Set([
  'homepageSlider',
  'homepageAlert',
  'homepageIcons',
]);
const SECOND_CONTAINER_BLOCK_TYPES = new Set([
  'homepageRollover',
  'homepageContact',
]);

const filterBlockLayout = (content, types) => ({
  ...content,
  blocks_layout: {
    items: (content.blocks_layout?.items || []).filter((blockId) =>
      types.has(content.blocks?.[blockId]?.['@type']),
    ),
  },
});

const HomePageBlocksView = (props) => {
  const { content } = props;
  const heroContent = filterBlockLayout(content, HERO_BLOCK_TYPES);
  const secondContent = filterBlockLayout(
    content,
    SECOND_CONTAINER_BLOCK_TYPES,
  );

  return (
    <div id="homepage-document">
      <div className="first-container">
        <RenderBlocks {...props} content={heroContent} />
      </div>
      <div className="second-container">
        <RenderBlocks {...props} content={secondContent} />
      </div>
    </div>
  );
};

HomePageBlocksView.propTypes = {
  content: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default HomePageBlocksView;
